import { GET } from '../request'

export const getCertificados = () =>
  GET('/api/core/alumnos/certificado-alumno/list')
